import ProjectApis from 'src/pages/Project/apis';
import ActivityApis from 'src/pages/Activity/apis';
import MonitorApis from 'src/pages/Monitor/apis';
import LoginApis from 'src/pages/Login/api';
import AnalysisApis from 'src/pages/Analysis/apis';
import DictionaryApis from 'src/pages/Dictionary/apis';
import BenefitApis from 'src/pages/Benefit/apis';
import BannerApis from 'src/pages/Banner/apis';
import BottomMenuApis from 'src/pages/BottomMenu/apis';
import SmsTemplateApis from 'src/pages/SmsTemplate/apis';
import NewsApis from 'src/pages/News/apis';
import HomepageApis from 'src/pages/Homepage/apis';
const apis = {
  project: new ProjectApis(),
  activity: new ActivityApis(),
  user: new LoginApis(),
  monitor: new MonitorApis(),
  analysis: new AnalysisApis(),
  dictionary: new DictionaryApis(),
  benefit: new BenefitApis(),
  banner: new BannerApis(),
  bottomMenu: new BottomMenuApis(),
  smsTemplate: new SmsTemplateApis(),
  news: new NewsApis(),
  homepage: new HomepageApis(),
};

export default apis;